(() => {
  const desktopCartLink = document.querySelector(
    "#cart-count-desktop > a"
  );

  if (!desktopCartLink) return;

  desktopCartLink.addEventListener("click", function (event) {
    event.preventDefault();
    event.stopPropagation();

    const oldDropdown = document.querySelector(
      "#cart-dropdown"
    );

    if (oldDropdown) {
      oldDropdown.style.display = "none";

      setTimeout(function () {
        oldDropdown.style.removeProperty("display");
      }, 300);
    }

    if (!window.Rebuy || !window.Rebuy.SmartCart) return;

    window.Rebuy.SmartCart.show();

    setTimeout(function () {
      if (typeof toggleCartButtons === "function") {
        toggleCartButtons();
      }
    }, 800);
  });
})();